import { render, staticRenderFns } from "./EditPackageItem.vue?vue&type=template&id=77e0e00c&scoped=true"
import script from "./EditPackageItem.vue?vue&type=script&lang=ts"
export * from "./EditPackageItem.vue?vue&type=script&lang=ts"
import style0 from "./EditPackageItem.vue?vue&type=style&index=0&id=77e0e00c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77e0e00c",
  null
  
)

export default component.exports